module.exports = __webpack_public_path__ + "static/media/cancelBanner.1f75a3ca.svg";